export const microToPercent = (price: number | null | string): string | null => {
  if (!price) {
    return null;
  }
  const value = +price * 100;
  return value.toFixed(value - Math.round(value) ? 1 : 0);
};

export const microToPercentWithPrecision = (
  percent: number | string | null | undefined,
  precision = 1
): string | null => {
  if (percent === null || percent === undefined || percent === '') {
    return null;
  }

  return (+percent * 100).toFixed(precision);
};

export const microToPercentStr = (micro?: number | string | null) => {
  if (!micro) {
    return null;
  }
  micro = `${micro}`;
  if (!micro.includes('.')) micro = `${micro}.0`;
  const [int, decP] = micro.split('.');
  const dec = decP.padEnd(3, '0');
  const str1 = dec.substring(0, 2);
  const str2 = dec.substring(2);
  const num = +`${int}${str1}.${str2 ?? ''}`;
  return `${num}`;
};
